import { useDispatch, useSelector } from "react-redux";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import Loadable from "../../../../components/loadable/Loadable";
import commonStyles from "../../FormSection.styles"
import { EDIT_FORM_ORIGIN, FORM_SECTION_ROUTES, QUERY_PARAMS } from "../../constants";
import { componentKey, setDownloadAllPDFModal, setDownloadMultiplePDFModal, setMergeFormsCheckbox, setPaginationState, setReferenceNumberList, setResubmitSuccessModal, setSelectedFederealResubmitGridData, setSelectedReferenceNumber } from "./FederalResubmitSlice";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import Button from "../../../../components/button/Button";
import RichGrid from "../../../../components/richgrid/RichGrid";
import Label from "../../../../components/label/Label";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import Payer from "../../../../../libs/utility/Payer";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import { useEffect } from "react";
import { federalResubmitDownloadAllPDF, federalResubmitDownloadMultiplePDF, federalResubmitForm, federalResubmitFormsExportToExcel, federalResubmitFormsExportToExcelForAll, federalResubmitViewPDF, getFederalResubmitGridData, getFederalResubmitReferenceList } from "./FederalResubmitSaga";
import Popup from "../../../../components/popup/Popup";
import CheckboxWLabel from "../../../../components/checkbox/checkboxwlabel/CheckboxWLabel";
import styles from "./FederalResubmit.styles"
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ResubmitSuccess from "./resubmitsuccess/ResubmitSuccess";
import Icons from "../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import { isAccessAllowed, useUserPermissionsInfo } from "../../../dashboard/hooks/userHooks";
import { PAGE_PERMISSIONS } from "../../../dashboard/constants/constant";
import { setShowPaymentNotAllowedPopup } from "../../../dashboard/DashboardSlice";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";
import useTxNavigate from "../../../../../libs/txnavigate/TxNavigateHook";
import General from "../../../../../libs/utility/General";
import useFormatTIN from "../../../../../libs/customhooks/useFormatTIN";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import Forms from "../../../../../libs/utility/formsutility/Forms";
import IconDropdown from "../../../../components/dropdown/icondropdown/IconDropdown";
import { IRS_FEDERAL_RESUBMIT_LOADING_STATES, IRS_FEDERAL_RESUBMIT_MESSAGE_MAP } from "../constant";

export default function FederalResubmitForms() {

    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const { permissions } = useUserPermissionsInfo();

    const { formatTIN } = useFormatTIN()

    const { loadingState, selectedReferenceNumber, referenceNumberList, federealResubmitGridData, selectedFederealResubmitGridData, paginationState, downloadAllPDFModal, downloadMultiplePDFModal, resubmitSuccessModal, mergeFormsCheckbox } = useSelector(state => state[componentKey]);

    useEffect(() => {
        const urlReferenceId = queryParams.get(QUERY_PARAMS.REFERENCE_ID);
        dispatch(getFederalResubmitReferenceList({ referenceId: urlReferenceId }));
    }, []);

    useEffect(() => {
        if (referenceNumberList.length && selectedReferenceNumber?.value) {
            dispatch(getFederalResubmitGridData({ paginationState, referenceId: selectedReferenceNumber?.value, referenceId: selectedReferenceNumber?.value }))
        }
    }, [selectedReferenceNumber, paginationState?.PageSize, paginationState?.PageNumber]);

    useEffect(() => {
        if (resubmitSuccessModal) {
            const queryObj = {
                [QUERY_PARAMS.REFERENCE_ID]:selectedReferenceNumber.label
            }
            const queryParamsStr = General.convertObjToQueryString(queryObj)
            navigate(`/forms/resubmitsuccess?${queryParamsStr}`);
        }
        dispatch(setResubmitSuccessModal(false));
    }, [resubmitSuccessModal])

    const DOWNLOAD_BULK_ACTION_BUTTONS = [
        {
            itemName: "Download All PDFs",
            onClick: () => {
                dispatch(setDownloadAllPDFModal(true));
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "Download Multiple PDFs",
            onClick: () => {
                if (selectedFederealResubmitGridData !== 0) {
                    dispatch(setDownloadMultiplePDFModal(true))
                } else {
                    dispatch(addNotifications({ heading: "Attention", message: "Please select a form to download", variant: TOASTER_VARIANT.WARNING }))
                }
            },
            styles: commonStyles.prmiaryText,
        },
    ]

    const EXPORT_BULK_ACTION_BUTTONS = [
        {
            itemName: "Export to Excel",
            onClick: () => {
                dispatch(federalResubmitFormsExportToExcel({ referenceId: selectedReferenceNumber?.value }))
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "Export to Excel For All",
            onClick: () => {
                dispatch(federalResubmitFormsExportToExcelForAll({ referenceId: selectedReferenceNumber?.value }))                
            },
            styles: commonStyles.prmiaryText,
        },
    ]

    const FEDERAL_RESUBMIT_FORMS_COLUMN = [
        {
            field: "Date",
            header: <Label weight={LABEL_WEIGHT[700]}>Date</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Date || "-"}</span>
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row.TINType, row.TIN) || "-"}</span>
        },
        {
            field: "Name",
            header: <Label weight={LABEL_WEIGHT[700]}>Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Name || "-"}</span>
        },
        {
            field: "Amount",
            header: <Label weight={LABEL_WEIGHT[700]}>Amount ($)</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Amount || "-"}</span>
        },
        {
            field: "RecipientEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Email</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.RecipientEmail || "-"}</span>
        },
        {
            field: "Action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => <div style={commonStyles.actionButtons}>
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'View/Print Form'} onClickCb={() => dispatch(federalResubmitViewPDF({ referenceId: selectedReferenceNumber?.value, formRecordId: row?.FormId }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit Form'}
                    onClickCb={() => { 
                        const queryObj = {
                            FormName: row?.FormShortName,
                            Year: row?.TaxYear,
                            FormRecordId:row?.FormId,
                            metaData:JSON.stringify({
                                [EDIT_FORM_ORIGIN] : FORM_SECTION_ROUTES.IRSSTATEREJECTED,
                                [QUERY_PARAMS.REFERENCE_ID]:selectedReferenceNumber.label
                            })
                        }
                        const queryParamsStr = General.convertObjToQueryString(queryObj)

                        navigate(`/forms/createnew?${queryParamsStr}`)
                    }}
                >
                        <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} />
                </Button>
            </div>
        },
    ];

    return (
        <>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <Loadable currentState={loadingState.state} loadingStates={[IRS_FEDERAL_RESUBMIT_LOADING_STATES.FETCHING_REFERENCES_LOADING]} messageMap={IRS_FEDERAL_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                        <SelectDropdown
                            name="selectedReferenceNumber"
                            label="Rejected Reference Number"
                            placeHolder="Select Reference Number"
                            options={referenceNumberList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedReferenceNumber(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.REFERENCE_ID, selectedOption?.label)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.REFERENCE_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedReferenceNumber}
                        />
                    </Loadable>


                    {selectedReferenceNumber?.value && <div style={styles.referenceInfoContainer}>
                        <Label>Form Name: {selectedReferenceNumber?.FormName}</Label>

                        <Label>Payer Name: {selectedReferenceNumber?.PayerName}</Label>

                        <Label>Tax Year: {selectedReferenceNumber?.TaxYear}</Label>
                    </div>}
                </div>
                {selectedReferenceNumber?.Reason && <div style={styles.rejectedReason}>
                    <Label> <b>Rejection Reason : </b></Label>
                    <span dangerouslySetInnerHTML={{ __html: General.sanitizeContent(Forms.replaceKeysInIRSLabelsWVariables(selectedReferenceNumber?.Reason, {})) }} />
                </div>}
            </div>

            {selectedReferenceNumber?.value ? <div style={commonStyles.buttonContainer}>
                    <div>
                        <IconDropdown
                            DropdownToggleComponent={<Icons iconName={VEC_ICON_NAME.CARET_DOWN} color="#215DAA" familyName="vec" />}
                            label="Download PDFs"
                            dropdownItems={DOWNLOAD_BULK_ACTION_BUTTONS}
                            dropdownContainerStyles={commonStyles.moreActionDropdown}
                            styles={commonStyles.moreActionDropdownLabel}
                            dropdownMenuStyle={commonStyles.moreActionDropdownMenu}
                        />
                    </div>
                    <div>
                        <IconDropdown
                            DropdownToggleComponent={<Icons iconName={VEC_ICON_NAME.CARET_DOWN} color="#215DAA" familyName="vec" />}
                            label="Export Excel"
                            dropdownItems={EXPORT_BULK_ACTION_BUTTONS}
                            dropdownContainerStyles={commonStyles.moreActionDropdown}
                            styles={commonStyles.moreActionDropdownLabel}
                            dropdownMenuStyle={commonStyles.moreActionDropdownMenu}
                        />
                    </div>

                    <div>
                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={{ ...commonStyles.button, ...styles.submitBtn }} onClickCb={() => {
                    if (selectedFederealResubmitGridData.length) {
                        if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                            dispatch(federalResubmitForm({ referenceId: selectedReferenceNumber?.value, FormIDs: selectedFederealResubmitGridData.map(item => item.FormId) }))
                        } else {
                            dispatch(setShowPaymentNotAllowedPopup(true))
                        }
                    } else {
                        dispatch(addNotifications({ heading: "Error", message: "Please select recipient details to submit to IRS" }))
                    }
                }}>Submit</Button>
                    </div>
            </div> : null}

            <div style={styles.gridContainer}>
                <Loadable currentState={loadingState.state} loadingStates={[IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_LOADING]} messageMap={IRS_FEDERAL_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                    <RichGrid
                        selectable={true}
                        data={federealResubmitGridData}
                        columns={FEDERAL_RESUBMIT_FORMS_COLUMN}
                        extractRowKey={(row) => row.FormId}
                        selectedRows={selectedFederealResubmitGridData}
                        onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedFederealResubmitGridData(selectedData))}
                        paginationProps={{
                            skip: paginationState?.Skip,
                            take: paginationState?.PageSize,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            total: paginationState?.total,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            },
                            onChange: (take, skip) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            }
                        }}
                    />
                </Loadable>
            </div>

            {downloadAllPDFModal &&
                <Popup
                    isPopupOpen={downloadAllPDFModal}
                    childrenStyles={styles.modalBody}
                    onCloseCb={() => {
                        dispatch(setDownloadAllPDFModal(false));
                        dispatch(setMergeFormsCheckbox(false));
                    }}
                >
                    <CheckboxWLabel
                        checked={mergeFormsCheckbox}
                        label="To merge all individual form PDF's into a single PDF, check the box and click OK."
                        onChangeCb={(e) => dispatch(setMergeFormsCheckbox(e.target.checked))}
                    />

                    <Button style={styles.okButton} onClickCb={() => {
                        dispatch(federalResubmitDownloadAllPDF({
                            payerId: selectedReferenceNumber?.PayerId,
                            referenceNo: selectedReferenceNumber?.value,
                            mergeCopies: mergeFormsCheckbox,
                        }))
                        dispatch(setDownloadAllPDFModal(false));
                    }}>Ok</Button>
                </Popup>
            }

            {downloadMultiplePDFModal &&
                <Popup
                    isPopupOpen={downloadMultiplePDFModal}
                    childrenStyles={styles.modalBody}
                    onCloseCb={() => {
                        dispatch(setDownloadMultiplePDFModal(false))
                        dispatch(setMergeFormsCheckbox(false));
                    }}
                >
                    <>
                        <CheckboxWLabel
                            checked={mergeFormsCheckbox}
                            label="To merge all individual form PDF's into a single PDF, check the box and click OK."
                            onChangeCb={(e) => dispatch(setMergeFormsCheckbox(e.target.checked))}
                        />

                        <Button style={styles.okButton} onClickCb={() => {
                            dispatch(federalResubmitDownloadMultiplePDF({
                                payerId: selectedReferenceNumber?.PayerId,
                                referenceNo: selectedReferenceNumber?.value,
                                mergeCopies: mergeFormsCheckbox,
                                formName: selectedReferenceNumber?.FormName,
                                payerName: selectedReferenceNumber?.PayerName,
                                taxYear: selectedReferenceNumber?.TaxYear,
                                FormIds: selectedFederealResubmitGridData?.map(f => f.FormId).toString()
                            }))
                            dispatch(setDownloadMultiplePDFModal(false));
                        }}>Ok</Button>
                    </>
                </Popup>
            }

        </>
    )
}